t = require('app/scripts/views/internal/teacup-with-helpers')('popover_emoji_completer')

module.exports = t.renderable ({ input, button, upsellEnabled }) ->
  if button
    t.input '.js-filter-emoji.js-autofocus', { type: 'text', placeholder: t.l('search-for-emoji-ellipsis') }

  t.div '.js-results', ->
    t.ul '.pop-over-emoji-list.js-available-emoji'

    if upsellEnabled
      t.hr()

      t.ul '.pop-over-list', ->
        t.li ->
            t.a '.js-upload-emoji', { href: '#', 'data-emojiname': '' }, ->
              t.format 'upload-emoji'

  t.div '.js-no-results.hide', ->
    if upsellEnabled
      t.p '.u-bottom.js-no-matching-emoji-helper'
      t.a '.button.primary.full.js-upload-emoji', { href: '#', 'data-emojiname': '' }
